// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2pYk9","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3kVtK"};